import React from 'react';
import { PageWatch, PageWatchProps } from './PageWatch/PageWatch';
import { PageInteractionsRecommendationButton } from './Recommendations/PageInteractionsRecommendationButton';
import { PageInteractionsPrintButton } from './Print/PageInteractionsPrintButton';
import { PageStatisticsButton } from './PageStatisticsButton';
import { PagePrintTreeForm } from './Print/PageInteractionsPrintPageForm';
import IForm from '../../../types/IForm';
import { LazyBlock } from '../../../types/api/Block';
import { BlockType } from '../../../types/api/ElementType';
import { useSonTranslation } from '../../../translation/useSonTranslation';
import { FavoriteButton } from '../../../components/forms/FavoriteButton/FavoriteButton';
import { Namespace } from '../../../translation/namespace';
import { Icons } from '../../../components/atoms/SVG';
import { BtnModifier } from '../../../components/molecules/Btn';
import { PageInteractionsRecommendationsProps } from './Recommendations/PageInteractionsRecommendationsForm';

export type PageInteractionsProps = {
  recommendationForm?: PageInteractionsRecommendationsProps['form'];
  pageStatistics?: LazyBlock<BlockType.pagestatistics>;
  watch?: PageWatchProps;
  favorite?: { form: IForm; active: boolean };
  printTree?: PagePrintTreeForm;
};

export function PageInteractions({
  recommendationForm,
  watch,
  favorite,
  pageStatistics,
  printTree,
}: PageInteractionsProps) {
  const { t } = useSonTranslation('PageInteractions');
  return (
    <div className="page-interactions">
      {recommendationForm && <PageInteractionsRecommendationButton form={recommendationForm} />}
      {watch && <PageWatch {...watch} />}
      {favorite && (
        <FavoriteButton
          id="page-favorite-action-form"
          translationNamespace={Namespace.PageInteractions}
          favoriteText={t('favorite.buttonText')}
          noFavoriteText={t('noFavorite.buttonText')}
          favorite={favorite}
          svgspriteId={Icons.FAVOURITE_HEART}
          color={BtnModifier.MINOR_ACTION_ACTIVATED_RED}
          resourceToInvalidate={BlockType.favoritedpages}
        />
      )}
      {pageStatistics && <PageStatisticsButton pageStatistics={pageStatistics} />}
      {printTree && <PageInteractionsPrintButton printTree={printTree} />}
    </div>
  );
}
